export default {
  education: {
    webinar: {
      title: "Зарегистрируйтесь на мероприятие, чтобы получить доступ к записи",
      text: "Вы можете автоматически авторизоваться с данными текущего аккаунта или внести данные вручную на следующем шаге.",
      label: "Регистрируясь вы принимаете",
      link: "условия передачи на сервис-партнера МТС Link",
      close: "Внести данные вручную",
      submit: "Зарегистрироваться",
    },
    metaTitle: "Образование",
    noContentLang: "На этом языке пока нет опубликованных материалов",
    titles: {
      material: "Обучение для врачей",
      course: "Обучающие курсы для врачей",
      simulator: "Тренажеры для врачей",
      webinar: "Вебинары для врачей",
    },
    filters: {
      selects: {
        type: {
          placeholder: "Вид материалов",
        },
        lang: {
          placeholder: "Язык",
        },
        status: {
          placeholder: "Статус",
          values: {
            actual: "Актуальные",
            overpast: "Прошедшие",
          },
        },
        specialty: {
          placeholder: "Специальность",
        },
      },
      tabs: {
        material: "Все материалы",
        course: "Курсы",
        simulator: "Тренажеры",
        webinar: "Вебинары",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "Ваши материалы",
          course: "Ваши курсы",
          simulator: "Ваши тренажеры",
          webinar: "Ваши вебинары",
        },
        recomended: {
          material: "Рекомендуемые материалы",
          course: "Рекомендуемые курсы",
          simulator: "Рекомендуемые тренажеры",
          webinar: "Рекомендуемые вебинары",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "Урок",
      Files: "Приложения",
      DownloadAll: "Скачать все",
    },
    status: {
      success: "Пройден",
      unsuccess: "Не пройден",
      stop: "Недоступно",
    },
  },
  Tests: {
    table: {
      tests: "Тесты",
      description: "Описание",
      points: "Баллы",
      status: "Статус",
    },
    modal: {
      title: "Вы хотите завершить тестирование?",
    },
    questions: {
      question: "Вопрос",
      answer: "Ответ",
      correct: "Верно",
      incorrect: "Неверно",
      moderated: "На проверке",
      navigation: "Навигация по тесту",
      enterAnswer: "Введите ответ...",
    },
    errors: {
      required: "Обязательный вопрос",
    },
    submit: " Завершить тестирование",
    result: "Результат",
    repeat: "Пройти заново",
  },
  afterPayCourse: {
    title: "Вы успешно приобрели курс",
    text: "Теперь у вас есть доступ к обучающим материалам",
    buttonText: "Перейти к курсу",
  },
  coursePage: {
    courseType: {
      course: "Курс",
      simulator: "Тренажер",
      webinar: "Вебинар",
    },
    groupNumber: "{n}-й поток",
    manager: "Менеджер",
    curator: "Куратор",
    free: "Бесплатно",
  },
  coursesPage: {
    materials: "Материалы",
    schools: "Авторские школы",
    universities: "ВУЗы",
    showPast: "Показать прошедшие",
    emptyList: "Таких материалов нет",
    show: "Показать",
    result1: "результат",
    result2: "результата",
    result5: "результатов",
    filters: "Фильтры",
    clear: "Очистить",
  },
};
